import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "left_menu" }
const _hoisted_2 = ["onClick"]

import { ref, toRefs } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    newsList: Object
},
  emits: ['clickChild'],
  setup(__props, { emit: __emit }) {

const props = __props
const { newsList } = toRefs(props) as any

const emit = __emit
let selectTagId = ref('')

const clickChild = (item: any) => {
    selectTagId.value = item.id
    emit('clickChild', item)
}
selectTagId.value = newsList.value[0].id

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsList), (item) => {
      return (_openBlock(), _createElementBlock("a", {
        class: _normalizeClass(["tit", { 'active': _unref(selectTagId) === item.id }]),
        onClick: ($event: any) => (clickChild(item)),
        key: item.id
      }, _toDisplayString(item.typeName), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})